import VersionsComparisonContainer from './version-comparison-container';

export default VersionsComparisonContainer;
